import React, { useState } from "react";

function BookingFooter() {
  const [submitted, setSubmitted] = useState(false);

  return (
    <section
      style={{
        background: "#171717",
        color: "#F5F2EB",
        padding: "100px 32px",
        textAlign: "center",
      }}
    >
      <div style={{ maxWidth: 720, margin: "0 auto" }}>
        <h2
          style={{
            fontFamily: "'Fraunces', serif",
            fontSize: "clamp(34px,5vw,52px)",
            marginBottom: 18,
          }}
        >
          Ready for your next stay?
        </h2>

        <p
          style={{
            color: "#C8C3B8",
            fontSize: 18,
            lineHeight: 1.8,
            marginBottom: 36,
          }}
        >
          Experience spacious serviced apartments designed for business,
          leisure and extended stays in Whitefield.
        </p>

        {!submitted ? (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              setSubmitted(true);
            }}
            style={{
              display: "flex",
              gap: 14,
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <input
              type="email"
              required
              placeholder="Email Address"
              style={{
                padding: "14px 18px",
                minWidth: 260,
                border: "none",
              }}
            />

            <button
              type="submit"
              style={{
                background: "#C9A66B",
                color: "#222",
                border: "none",
                padding: "14px 28px",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Request Availability
            </button>
          </form>
        ) : (
          <p
            style={{
              marginTop: 20,
              color: "#C9A66B",
              fontFamily: "'JetBrains Mono', monospace",
            }}
          >
            Thank you! We'll get back to you shortly.
          </p>
        )}

        <div
          style={{
            marginTop: 70,
            borderTop: "1px solid rgba(255,255,255,.12)",
            paddingTop: 28,
            color: "#B8B3A8",
            lineHeight: 1.8,
          }}
        >
          <strong>Ebenezer Serviced Apartments & Suites</strong>
          <br />
          Kothanur, Bengaluru
          <br />
          Near Manyata Tech Park • New International Airport • Kristu Jayanti College
        </div>
      </div>
    </section>
  );
}

export default BookingFooter;